// plugins/phone-ua.ts — реєстрація директиви v-phone-ua.
// Реалізація і поведінка: utils/phoneUaDirective.ts
import { phoneUaDirective } from "~/utils/phoneUaDirective";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("phone-ua", phoneUaDirective);
});
